<template>
  <div>
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        指标得分明细
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索指标得分规则/服务资源名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <el-table-column prop="name" label="服务资源" width="180px" fixed>
            <template slot-scope="scope">
              {{ scope.row.exts.userName || scope.row.exts.serviceCrewName }}
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="tableEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="getRank(scope.row)">
                    查看历史记录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="指标得分明细" :visible.sync="openDetail" width="700px">
      <c-form
        :area="area"
        :upload="upload"
        :options="options"
        :formData="formData"
        :fields="extFields"
        ref="form"
        labelWidth="100px"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="指标得分修改记录"
      :visible.sync="popupMode"
      :close-on-click-modal="false"
      width="1000px"
      class="c-dialog-rank"
    >
      <el-table ref="table" :data="changeRecord" empty-text="暂无数据">
        <el-table-column label="得分值(修改前)">
          <template #default="{ row }">
            {{ getFieldValue(row.modifyList, 'scoreVal', 'pfrom') }}
          </template>
        </el-table-column>
        <el-table-column label="得分值(修改后)">
          <template #default="{ row }">
            {{ getFieldValue(row.modifyList, 'scoreVal', 'pto') }}
          </template>
        </el-table-column>
        <el-table-column label="指标值(修改前)">
          <template #default="{ row }">
            {{ getFieldValue(row.modifyList, 'indexVal', 'pfrom') }}
          </template>
        </el-table-column>
        <el-table-column label="指标值(修改后)">
          <template #default="{ row }">
            {{ getFieldValue(row.modifyList, 'indexVal', 'pto') }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="updateTime"></el-table-column>
        <el-table-column label="修改人" prop="updateUserName"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'scoreDetail',
  data() {
    window.$this = this;
    return {
      name: 'scoreDetail',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      popupMode: false, //修改一个
      extFields: [],
      changeRecord: [],
      formData: {
        exts: {}
      },
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.osg.getFields('scoreDetail', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:exts.ruleName|string#or': this.searchValue,
        'regex:exts.userName|string#or': this.searchValue,
        'regex:exts.serviceCrewName|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/scoreDetail/query.do', params, res => {
        res.data.map(item => {
          item.exts = item.exts || {};
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doEnable(id) {
      this.osg.ajax('biz/scoreDetail/enable.do', { id }, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.confirm('是否确认禁用？禁用将清空得分值！', () => {
        this.osg.ajax('biz/scoreDetail/disable.do', { id }, () => {
          this.osg.toast('禁用成功');
          this.getData();
        });
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('biz/scoreDetail/delete.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //编辑 保存按钮
    doSave() {
      console.log('保存按钮', this.formData);
      //钱拷贝一下
      let { _id, scoreVal, indexVal } = this.formData;
      let params = { id: _id, scoreVal, indexVal };
      console.log(11122233, params);
      this.osg.ajax('biz/scoreDetail/updateValue.do', params, () => {
        this.osg.toast('保存成功');
        this.doInit();
        this.getData();
      });
    },
    //编辑弹窗 取消按钮
    doInit() {
      //重置表单
      this.formData = {
        exts: {}
      };
      this.openDetail = false;
    },
    //表格 编辑按钮
    tableEdit(row) {
      //管家 userId
      //服务商 serviceCrewId
      //指标得分规则 ruleName
      //指标得分规则 ruleId
      //得分值 scoreVal
      //指标值 indexVal
      //行政区划 region
      //探针事件 probe
      //权重 weight
      //权重总数 weightTotal
      //权重总分 scoreValWeight
      this.formData = this.$util.deepCopy(row);
      this.openDetail = true;
    },
    //查看修改记录
    getRank(row) {
      console.log('这一条明细', row);
      this.popupMode = true;
      let params = {
        smodule: 'scoreDetail',
        sid: row._id,
        _all: 1
      };

      this.osg.ajax('biz/changeLog/query.do', params, res => {
        this.changeRecord = res.data;
      });
    },
    getFieldValue(row, field, key) {
      if (Array.isArray(row)) {
        const item = row.find(item => item.field == field);
        return item ? item[key] : '';
      }
      return ''; // 如果 modifyList 不存在或为空，返回空字符串
    }
  }
};
</script>
<style lang="scss"></style>
